import React, {ReactElement, useState} from 'react'

import "styles/components/popup.sass"
import "pages/Styles/UIKit.sass"

import {CircularProgress} from "@mui/material";
import Popup from "../../../components/Popup";
import {connect} from "react-redux";
import ApiKeyField from "../../../components/ApiKeyField";
import TemplateIntegrationSettings from "../../../components/TemplateIntegrationSettings";

type Props = {
    serviceName: string,
    helpView: ReactElement,
    close: Function,
    roomsharingConfig: any,
    $store: any,
    $commitToStore: Function,
}

let RoomSharingIntegrationPopup: any = function RoomSharingIntegrationPopup(props: Props) {
    const [loading, setLoading] = useState(false)

    return <Popup
        maxWidth="650px"
        onClose={() => {
            props.close()
        }}
    >
        <div>
            {
                props.helpView
            }
            <hr className="newHR"/>
            
            {/* API Key Field */}
            <ApiKeyField
                title="API ключ для интеграции"
                value={props.$store.userSession.realty_api_key || ''}
                placeholder="API ключ будет сгенерирован автоматически"
                copyMessage="API ключ скопирован в буфер обмена"
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />

            <hr className="newHR"/>
            
            <div className="Body_15" style={{textAlign: "left"}}>
                {`Настройте интеграцию с ${props.serviceName}. Выберите тип работы с шаблонами договоров:`}
            </div>
            
            <TemplateIntegrationSettings
                serviceName={props.serviceName}
                placeholderText={`Введите id объекта из ${props.serviceName}`}
                integrationConfig={props.roomsharingConfig}
                integrationFieldName="roomsharing_integration"
                idFieldName="realty_id"
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />

            <hr className="newHR"/>
            <button
                className="new withTitle _wa"
                disabled={loading}
                style={{marginTop: "15px"}}
                onClick={() => {
                    props.close()
                }}
            >
                <div className="buttonsContainer">
                    {
                        loading &&
                        <CircularProgress size={"25px"} sx={{color: "#1FA3EE"}} />
                    }
                    <span>Сохранить и закрыть</span>
                </div>
            </button>
        </div>
    </Popup>
}

RoomSharingIntegrationPopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(RoomSharingIntegrationPopup)

export default RoomSharingIntegrationPopup
